export enum CallDispositionOutcome {
  CONNECTED = "CONNECTED",
  NOT_CONNECTED = "NOT_CONNECTED",
  NEUTRAL = "NEUTRAL",
}
